import * as actionTypes from '../../constants/ActionTypes/HardwareInclusive/HardwareInclusive'

export const GetHardwareInclusivePrinterFeaturesByPrinterType = (payloadForFeatureSwitch) => ({
    type: actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE,
    payloadForFeatureSwitch
})

export const GetHardwareInclusiveServicePlan = (model) => ({
    type: actionTypes.GET_HW_SERVICE_PLAN,
    model
})

export const GetHardwareInclusivePrinterByFeatures = (printerTypeId, deviceUsageTypeId, featureIds, bonusPages) => ({
    type: actionTypes.GET_HW_PRINTER_BY_FEATURES,
    printerTypeId,
    deviceUsageTypeId,
    featureIds,
    bonusPages
})

export const HWInclusive_ManageInstantPayment = (payload) => ({
    type: actionTypes.HWINCLUSIVE_MANAGE_INSTANT_PAYMENT_INIT,
    payload
})

export const HWInclusive_ManageInstantPaymentReset = () => ({
    type: actionTypes.HWINCLUSIVE_MANAGE_INSTANT_PAYMENT_RESET
})

export const resetHWServicePlan = () => ({
    type: actionTypes.GET_HW_SERVICE_PLAN_RESET
})

export const resetHWPrinterFeatureByType = () => ({
    type: actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE_RESET
})

export const resetHWPrinterByFeature = () => ({
    type: actionTypes.GET_HW_PRINTER_BY_FEATURES_RESET
})

export const fetchHardwareInclusiveCounter = (countryCode) => ({
  type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_INIT ,
  countryCode
});